import * as basicLightbox from "basiclightbox";

export default class productLineSlider {

    constructor() {
        this.container = document.querySelector('.product-line-slider');
        this.mainSlider = document.getElementById('product-line-slider_main');
        this.thumbSlider = document.getElementById('product-line-slider_thumbs');
        this.slides = document.querySelectorAll('.product-line-slider__content__cont');
        this.storyThumbs = document.querySelectorAll('.story_thumb');

        // Is the element present on the current page
        if (!this.container) {
            return;
        }
        this.slider();
        this.sliderThumbs();
        this.sliderCustom();

        setTimeout(_ => {
            this.thumbspositionsmobile();
        }, 500);


        this.CurrentSlideByHash();

        /** Trigger on browser resize */
        window.addEventListener('resize', () => {
            setTimeout(_ => {
                this.thumbspositionsmobile();
            }, 300);
        });
        /** Trigger on mobile orientation change */
        window.addEventListener("orientationchange", () => {
            setTimeout(_ => {
                this.thumbspositionsmobile();
            }, 300);
        });

        /** Change hash in url on slide change */
        $('#product-line-slider_thumbs').on('afterChange', function(event, slick, currentSlide, nextSlide){
            window.location.hash = $('.line-slug[data-id=' + (currentSlide + 1) + ']').text();
        });

        /** Tabs croll on click */
        $('.product-line-slider .accordion-item').on('click', function(e){
            setTimeout(_ => {
                $('html, body').animate({
                    scrollTop: $(this).offset().top - 80
                }, 1000);
            }, 1000);
        });

        /** Basic lightbox */
        $('.story_thumb').on('click', function(e){
                //console.log($(this).attr("data-url"));
                basicLightbox.create('<iframe width="90%" height="90%" src="' + $(this).attr("data-url") + '" frameborder="0" allowfullscreen></iframe>').show();
         });

        /** Circle resize */
        this.circleResize();
        /** Trigger on browser resize */
        window.addEventListener('resize', () => {
            this.circleResize();
        });
        /** Trigger on mobile orientation change */
        window.addEventListener("orientationchange", () => {
            this.circleResize();
        });
    }

    slider() {
        $('#product-line-slider_main').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            autoWidth: false,
            speed: 800,
            autoplay: false,
            autoplaySpeed: 6000,
            centerPadding: 0,
            //lazyLoad: 'anticipated', // ondemand, progressive, anticipated
            fade: true,
            cssEase: 'ease',
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false,
            draggable: false,
            swipe: true,
            initialSlide: 0,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        draggable: true,
                        asNavFor: '#product-line-slider_thumbs'
                    }
                }
            ]
        });
    }

    sliderThumbs() {
        $('#product-line-slider_thumbs').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            autoWidth: false,
            speed: 800,
            autoplay: false,
            autoplaySpeed: 6000,
            centerPadding: 0,
            //lazyLoad: 'anticipated', // ondemand, progressive, anticipated
            fade: false,
            cssEase: 'ease',
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false,
            draggable: true,
            swipe: true,
            asNavFor: '#product-line-slider_main',
            initialSlide: 0,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '250px',
                    }
                },
                {
                    breakpoint: 951,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '240px',
                    }
                },
                {
                    breakpoint: 911,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '230px',
                    }
                },
                {
                    breakpoint: 881,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '220px',
                    }
                },
                {
                    breakpoint: 851,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '210px',
                    }
                },
                {
                    breakpoint: 801,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '200px',
                    }
                },
                {
                    breakpoint: 751,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '190px',
                    }
                },
                {
                    breakpoint: 721,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '180px',
                    }
                },
                {
                    breakpoint: 681,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '170px',
                    }
                },
                {
                    breakpoint: 641,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '160px',
                    }
                },
                {
                    breakpoint: 601,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '150px',
                    }
                },
                {
                    breakpoint: 571,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '140px',
                    }
                },
                {
                    breakpoint: 531,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '130px',
                    }
                },
                {
                    breakpoint: 481,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '120px',
                    }
                },
                {
                    breakpoint: 451,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '110px',
                    }
                },
                {
                    breakpoint: 401,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '100px',
                    }
                },
                {
                    breakpoint: 365,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '90px',
                    }
                },
                {
                    breakpoint: 341,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '80px',
                    }
                }
            ]
        });
    }

    sliderCustom() {
        // Remove active class from all thumbnail slides
       // $('#product-line-slider_thumbs .slick-slide').removeClass('slick-active');

        // Set active class to first thumbnail slides
       //$('#product-line-slider_thumbs .slick-slide').eq(0).addClass('slick-active');

        // On before slide change match active thumbnail to current slide
        //$('#product-line-slider_main').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
           // var mySlideNumber = nextSlide;
           // $('#product-line-slider_thumbs .slick-slide').removeClass('slick-active');
           // $('#product-line-slider_thumbs .slick-slide').eq(mySlideNumber).addClass('slick-active');
        //});

        // Custom carousel nav
        $('.product-line-slider__nav__left').click(function(){
            $('#product-line-slider_main').slick('slickPrev');
        } );

        $('.product-line-slider__nav__right').click(function(){
            $('#product-line-slider_main').slick('slickNext');
        } );

        // After slider load remove loading
        /*$('.product-line-slider').on('lazyLoaded', function(event, slick, currentSlide, nextSlide){
            setTimeout(function(){
                $('.product-line-slider').addClass('activated');
            }, 1000);
        });*/


    }

    thumbspositionsmobile() {
        /* Mobile thumbs position */
        //$('.product-line-slider').on('init', function(event, slick, currentSlide, nextSlide){
            const thumbNav = document.querySelector('.product-line-slider__thumbnails');
            const contentTitleAll = document.querySelectorAll('.product-line-slider__content');
            const bgImageheight = document.querySelector('.product-line-slider__bgimage__img').offsetHeight;
            // Define the media query
            const mediaQuery = window.matchMedia('(max-width: 767px)');
            if (mediaQuery.matches) {
                thumbNav.style.top = bgImageheight -210 + 'px';
                var i;
                for (i = 0; i < contentTitleAll.length; i++) {
                    contentTitleAll[i].style.marginTop = bgImageheight + 60 + 'px';
                    console.log(bgImageheight);
                }
            } else {
                thumbNav.style.top = '';
                var i;
                for (i = 0; i < contentTitleAll.length; i++) {
                    contentTitleAll[i].style.marginTop = '';
                }
            }
        //});
    }
    CurrentSlideByHash() {
        var i;
        for (i = 0; i < this.slides.length; i++) {
            const lineSlug = this.slides[i].querySelector('.line-slug');
            const hash = window.location.hash.replace(/#|open/g,'');

            /** If access the page without hash add hash of the first slide */
            if (hash === '') {
                window.location.hash = this.slides[0].querySelector('.line-slug').textContent;
            }
            /** Display slide based on hash in url */
            if (hash === lineSlug.textContent) {
                $('#product-line-slider_main').slick('slickGoTo', lineSlug.dataset.id - 1);
                $('#product-line-slider_thumbs').slick('slickGoTo', lineSlug.dataset.id - 1);
            }
            /** Go to the specific slide on button click */
            $('.button-to-slide').on('click', function(e){
                const butValue = $(this).attr("href").replace(/#|open/g,'');
                if (butValue === lineSlug.textContent) {
                    $('#product-line-slider_main').slick('slickGoTo', lineSlug.dataset.id - 1);
                    $('#product-line-slider_thumbs').slick('slickGoTo', lineSlug.dataset.id - 1);
                    window.scrollTo(0, 0);
                }
            });
        }
        /** On browser back/forward button */
        window.onpopstate = function(event) {
            const slides = document.querySelectorAll('.product-line-slider__content__cont');
            var i;
            for (i = 0; i < slides.length; i++) {
                const lineSlug = slides[i].querySelector('.line-slug');
                const hash = window.location.hash.replace(/#|open/g,'');
                /** Display slide based on hash in url */
                if (hash === lineSlug.textContent) {
                    $('#product-line-slider_main').slick('slickGoTo', lineSlug.dataset.id - 1);
                    $('#product-line-slider_thumbs').slick('slickGoTo', lineSlug.dataset.id - 1);
                }
            }
        };

    }


    circleResize() {
        const logos_container = this.container;
        this.logos_section = document.querySelector('.logos-section');
        if(this.logos_section) {
        this.width = window.innerWidth;
        this.logosHeight = this.logos_section ? this.logos_section.offsetHeight : 100;
        this.logosHeightMob = this.logos_section ? this.logos_section.offsetHeight : 0;
        // Define the media query
        const mediaQuery = window.matchMedia('(max-width: 991px)');
        this.circle = logos_container.querySelector('.circle');
            if (mediaQuery.matches) {
                this.circle.style.width = this.width * 2.5 + 'px';
                this.circle.style.height = this.width * 2.5 + 'px';
                //this.circle.style.top = '-50px';s
                this.circle.style.bottom = '-' + (this.width * 2.65) + 'px';
                this.circle.style.left = '-' + (this.width + 10) + 'px';
            } else {
                this.circle.style.width = this.width + 'px';
                this.circle.style.height = this.width + 'px';
                //this.circle.style.top = 'auto';
                this.circle.style.bottom = '-' + (this.width + this.logosHeight + 100) + 'px';
                this.circle.style.left = '-' + (this.width / 3 - 50) + 'px';
            }
        }
    }

}
